export default {
  dateString(date) {
    return (new Date(date)).toLocaleDateString().replace(/\//g, '-');
  },
  dateTimeString(date) {
    return (new Date(date)).toLocaleString().replace(/\//g, '-');
  },
  timeString(date) {
    return (new Date(date)).toLocaleTimeString().replace(/\//g, '-');
  },
  formatTime(date) {
    return (new Date(date)).toLocaleString();
  },
  formatTitle(str, num) {
    if (str.title.length > num) {
      str.title = `${str.title.slice(0, num)}...`;
    }
    return str.title;
  },
  formatAbstract(str, num) {
    if (str.abstract.length > num) {
      str.abstract = `${str.abstract.slice(0, num)}...`;
    }
    return str.abstract;
  },
  changeImageUrl(url, type) {
    if (!url) return '';
    return url.replace(/\/original\//g, `/${type}/`);
  },
  // 附件预览
  onPreview(url) {
    if (!url) return;
    const ary = url.split('?')[0].split('.');
    const type = ary[ary.length - 1];

    if (type === 'pdf') {
      window.open(url);
    } else {
      const previewUrl = `https://view.officeapps.live.com/op/view.aspx?src=${url}`;
      window.open(previewUrl, 'blank');
    }
  },
  // 培训状态 train_activity
  getTrainActivityState(state) {
    return {
      to_be_start: '未开始',
      processing: '培训中',
      closed: '已完成',
    }[state.toString()];
  },
};



// WEBPACK FOOTER //
// ./src/plugins/utils.js